module.exports = {"131003001":"银河北路街道","131003002":"爱民东道街道","131003003":"解放道街道","131003004":"新开路街道","131003005":"新源道街道","131003100":"南尖塔镇","131003101":"万庄镇","131003102":"九州镇","131003103":"北旺镇","131003500":"新世纪步行街服务中心"}


//////////////////
// WEBPACK FOOTER
// ./src/town/131003.json
// module id = 320
// module chunks = 0